/**
 * @ngdoc config
 * @name routeProviderConfig
 * @description
 * Sets the routes for the Community section:
 * - The default one (`/`).
 *
 * @param {Service} $routeProvider The interface for the Angular router.
 * @memberof community
 */
const routeProviderConfig = ($routeProvider) => {
  'ngInject';

  $routeProvider
  .when('/community', {
    template: '<community></community>',
  });
};

export default routeProviderConfig;



// WEBPACK FOOTER //
// ./src/frontend/modules/community/configs/routeProvider.config.js